<!--<div-->
<!--  class="md:hidden px-4 py-10 bg-white flex-col justify-start items-start gap-8 inline-flex w-full"-->
<!--  *transloco="let t; prefix: 'find-property'"-->
<!--&gt;-->
<!--  <div class="self-stretch text-black text-[28px] font-semibold">-->
<!--    {{ t("header") }}-->
<!--  </div>-->

<!--  <div class="self-stretch">-->
<!--    <app-search-property-->
<!--      [searchPlaceholder]="t('maps-search.search-placeholder')"-->
<!--      (SearchSelected)="searchWithLocation($event)"-->
<!--      [searchPlaceholder]="t('searchProperty')"-->
<!--      (ItemSelected)="selectSearchItem($event)"-->
<!--    [searchByCode]="true"-->
<!--    />-->
<!--  </div>-->
<!--  <div class="self-stretch flex-col justify-start items-start gap-4 flex">-->
<!--    <div class="justify-start items-center gap-4 inline-flex">-->
<!--      <button-->
<!--        class="w-14 h-14 rounded-full border border-gray-300 justify-center items-center inline-flex"-->
<!--        (click)="toggleAdvancedFilers()"-->
<!--      >-->
<!--        <div class="w-9 h-9 relative flex flex-col">-->
<!--          <div-->
<!--            class="w-full h-full absolute rounded-full flex items-center justify-center text-white font-bold"-->
<!--          >-->
<!--            <svg-->
<!--              width="24"-->
<!--              height="24"-->
<!--              viewBox="0 0 24 24"-->
<!--              fill="none"-->
<!--              xmlns="http://www.w3.org/2000/svg"-->
<!--            >-->
<!--              <g id="filter">-->
<!--                <g id="Union">-->
<!--                  <path-->
<!--                    d="M2 6.72C2 6.32236 2.32236 6 2.72 6H21.92C22.3176 6 22.64 6.32236 22.64 6.72C22.64 7.11765 22.3176 7.44 21.92 7.44H2.72C2.32236 7.44 2 7.11765 2 6.72Z"-->
<!--                    fill="black"-->
<!--                  ></path>-->
<!--                  <path-->
<!--                    d="M4.4 12.72C4.4 12.3224 4.72235 12 5.12 12H19.52C19.9176 12 20.24 12.3224 20.24 12.72C20.24 13.1176 19.9176 13.44 19.52 13.44H5.12C4.72235 13.44 4.4 13.1176 4.4 12.72Z"-->
<!--                    fill="black"-->
<!--                  ></path>-->
<!--                  <path-->
<!--                    d="M8.72 18C8.32236 18 8 18.3224 8 18.72C8 19.1176 8.32236 19.44 8.72 19.44H15.92C16.3176 19.44 16.64 19.1176 16.64 18.72C16.64 18.3224 16.3176 18 15.92 18H8.72Z"-->
<!--                    fill="black"-->
<!--                  ></path>-->
<!--                </g>-->
<!--              </g>-->
<!--            </svg>-->
<!--          </div>-->
<!--          <div-->
<!--            class="w-5 h-5 absolute -top-[10px] left-8 bg-green-600 rounded-full flex flex-col justify-center"-->
<!--          >-->
<!--            <span class="text-white text-xs">{{ searchFiltersCount }}</span>-->
<!--          </div>-->
<!--        </div>-->
<!--      </button>-->
<!--      <div class="text-black text-base font-normal">-->
<!--        {{ t("searchFilters") }}-->
<!--      </div>-->
<!--    </div>-->

<!--    @if (isAnyFilterSelected) {-->
<!--      <div class="rounded-[999px] justify-center items-center gap-2 flex">-->
<!--        <button-->
<!--          class="text-[#576774] text-base font-normal underline"-->
<!--          (click)="removeQueryParams()"-->
<!--        >-->
<!--          {{ t("advanced-filters-drawer.filters.buttons.clear") }}-->
<!--        </button>-->
<!--      </div>-->
<!--    }-->
<!--  </div>-->
<!--  <div class="h-16 flex-col justify-start items-start gap-6 inline-flex">-->
<!--    @if (isAnyFilterSelected) {-->
<!--      <button-->
<!--        class="rounded-full justify-center items-center gap-2 flex"-->
<!--        (click)="SaveSearch()"-->
<!--      >-->
<!--        <div class="w-5 h-5 relative">-->
<!--          <i class="icon-heart-line text-green-700 text-md font-normal"></i>-->
<!--        </div>-->
<!--        <button class="text-green-700 text-base font-normal">-->
<!--          {{ t("grid-list-cards.buttons.saveSearch") }}-->
<!--        </button>-->
<!--      </button>-->
<!--    }-->
<!--    <div class="rounded-full justify-center items-center gap-2 flex">-->
<!--      <button-->
<!--        [localizedRouterLink]="['/account-settings/saved-searches']"-->
<!--        routerLinkActive="router-link-active"-->
<!--        class="text-green-700 text-base font-normal underline"-->
<!--      >-->
<!--        {{ t("allSavedSearches") }}-->
<!--      </button>-->
<!--    </div>-->
<!--  </div>-->
<!--</div>-->
<!--<div-->
<!--  class="inline-flex w-full pt-8 bg-white flex-col justify-start items-start gap-8 lg:sticky top-[-18px] z-10"-->
<!--  *transloco="let t; prefix: 'find-property'"-->
<!--&gt;-->
<!--  <div-->
<!--    class="hidden md:inline-flex px-[72px] self-stretch justify-between items-center"-->
<!--  >-->
<!--    <div class="grow shrink basis-0 text-black text-[32px] font-semibold">-->
<!--      {{ t("header") }}-->
<!--    </div>-->

<!--    <div class="justify-start items-center gap-6 flex">-->
<!--      @if (isAnyFilterSelected) {-->
<!--        <button-->
<!--          class="rounded-full justify-center items-center gap-2 flex"-->
<!--          (click)="SaveSearch()"-->
<!--        >-->
<!--          <div class="w-5 h-5 relative">-->
<!--            <i class="icon-heart-line text-green-700 text-md font-normal"></i>-->
<!--          </div>-->
<!--          <div class="text-green-700 text-base font-normal">-->
<!--            {{ t("grid-list-cards.buttons.saveSearch") }}-->
<!--          </div>-->
<!--        </button>-->
<!--        <div class="w-[18px] h-[0px] rotate-90 border border-gray-400"></div>-->
<!--      }-->
<!--      <button-->
<!--        [localizedRouterLink]="['/account-settings/saved-searches']"-->
<!--        class="rounded-rounded justify-center items-center gap-2 flex"-->
<!--      >-->
<!--        <div class="text-green-700 text-base font-normal underline">-->
<!--          {{ t("allSavedSearches") }}-->
<!--        </div>-->
<!--      </button>-->
<!--    </div>-->
<!--  </div>-->
<!--  <div class="hidden md:block w-full px-[72px] self-stretch">-->
<!--    <app-search-property-->
<!--      [searchPlaceholder]="t('maps-search.search-placeholder')"-->
<!--      (ItemSelected)="selectSearchItem($event)"-->
<!--      (SearchSelected)="searchWithLocation($event)"-->
<!--    [searchByCode]="true"/>-->
<!--  </div>-->

<!--  <div-->
<!--    class="hidden md:inline-flex px-[72px] xl:self-stretch justify-between items-start md:items-center flex flex-col self-center gap-8 xl:flex-row"-->
<!--  >-->
<!--    <div class="h-14 justify-between items-center gap-12 flex w-full">-->
<!--      <app-filter-dropdown-->
<!--        [dropdownItems]="propertyTypes"-->
<!--        [title]="t('filterTitles.propertyType')"-->
<!--        [selectedKeys]="selectedType"-->
<!--        [allValuesLabel]="t('filterAllValuesLabels.propertyType')"-->
<!--        (selectedItem)="searchWithTypeFilter($event)"-->
<!--        class="w-full z-10"-->
<!--      ></app-filter-dropdown>-->

<!--      <app-range-dropdown-->
<!--        [minDropdownItems]="minPriceRanges"-->
<!--        [maxDropdownItems]="maxPriceRanges"-->
<!--        [title]="t('filterTitles.price')"-->
<!--        [preselectedRange]="selectedPriceRange"-->
<!--        [allValuesLabel]="t('filterAllValuesLabels.price')"-->
<!--        postfix="€"-->
<!--        (selectedRangeEvent)="searchWithPriceFilter($event)"-->
<!--        class="w-full z-10"-->
<!--      ></app-range-dropdown>-->

<!--      <app-range-dropdown-->
<!--        [minDropdownItems]="minSizeRanges"-->
<!--        [maxDropdownItems]="maxSizeRanges"-->
<!--        [title]="t('filterTitles.size')"-->
<!--        [preselectedRange]="selectedSizeRange"-->
<!--        [allValuesLabel]="t('filterAllValuesLabels.size')"-->
<!--        [postfix]="areaUnit"-->
<!--        (selectedRangeEvent)="searchWithSizeFilter($event)"-->
<!--        class="w-full z-10"-->
<!--      ></app-range-dropdown>-->
<!--    </div>-->
<!--    <div class="justify-end items-center gap-5 flex w-full xl:w-1/3">-->
<!--      @if (isAnyFilterSelected) {-->
<!--        <div class="rounded-[999px] justify-center items-center gap-2 flex">-->
<!--          <button-->
<!--            class="text-[#576774] text-base font-normal underline"-->
<!--            (click)="removeQueryParams()"-->
<!--          >-->
<!--            {{ t("advanced-filters-drawer.filters.buttons.clear") }}-->
<!--          </button>-->
<!--        </div>-->
<!--      }-->

<!--      <button-->
<!--        class="w-14 h-14 rounded-full border border-gray-300 justify-center items-center inline-flex"-->
<!--        (click)="toggleAdvancedFilers()"-->
<!--      >-->
<!--        <div class="w-9 h-9 relative flex flex-col">-->
<!--          <div-->
<!--            class="w-full h-full absolute rounded-full flex items-center justify-center text-white font-bold"-->
<!--          >-->
<!--            <svg-->
<!--              width="24"-->
<!--              height="24"-->
<!--              viewBox="0 0 24 24"-->
<!--              fill="none"-->
<!--              xmlns="http://www.w3.org/2000/svg"-->
<!--            >-->
<!--              <g id="filter">-->
<!--                <g id="Union">-->
<!--                  <path-->
<!--                    d="M2 6.72C2 6.32236 2.32236 6 2.72 6H21.92C22.3176 6 22.64 6.32236 22.64 6.72C22.64 7.11765 22.3176 7.44 21.92 7.44H2.72C2.32236 7.44 2 7.11765 2 6.72Z"-->
<!--                    fill="black"-->
<!--                  ></path>-->
<!--                  <path-->
<!--                    d="M4.4 12.72C4.4 12.3224 4.72235 12 5.12 12H19.52C19.9176 12 20.24 12.3224 20.24 12.72C20.24 13.1176 19.9176 13.44 19.52 13.44H5.12C4.72235 13.44 4.4 13.1176 4.4 12.72Z"-->
<!--                    fill="black"-->
<!--                  ></path>-->
<!--                  <path-->
<!--                    d="M8.72 18C8.32236 18 8 18.3224 8 18.72C8 19.1176 8.32236 19.44 8.72 19.44H15.92C16.3176 19.44 16.64 19.1176 16.64 18.72C16.64 18.3224 16.3176 18 15.92 18H8.72Z"-->
<!--                    fill="black"-->
<!--                  ></path>-->
<!--                </g>-->
<!--              </g>-->
<!--            </svg>-->
<!--          </div>-->
<!--          <div-->
<!--            class="w-5 h-5 absolute -top-[10px] left-8 bg-green-600 rounded-full flex flex-col justify-center"-->
<!--          >-->
<!--            <span class="text-white text-xs">{{ searchFiltersCount }}</span>-->
<!--          </div>-->
<!--        </div>-->
<!--      </button>-->
<!--    </div>-->
<!--  </div>-->
<!--  <app-property-list-header-->
<!--    [sortKeyMapping]="this.sortKeyMapping"-->
<!--    [selectedItem]="this.selectedItem"-->
<!--    [orderByItems]="this.orderByItems"-->
<!--    [queryParamSortString]="this.queryParamSortString"-->
<!--    [propertyCount]="this.propertyCount"-->
<!--    (onViewChange)="this.displayMap = $event"-->
<!--  />-->
<!--</div>-->
<ng-container *transloco="let t; prefix: 'find-property'">
  <div
    class="sticky lg:top-0 z-[11] px-4 sm:px-8 lg:px-[3rem] xl:px-[4.5rem] py-6 bg-white md:shadow-[0px_6px_16px_0px_#0000001F] flex flex-col gap-8"
    [ngClass]="[headingHeight === 84 ? 'top-[-110px]' : 'top-[-32px]']">
    <div class="flex flex-col lg:flex-row gap-4 items-start lg:items-center justify-between w-full">
      <h2 #headingElement class="grow shrink basis-0 text-black text-[28px] md:text-[32px] font-semibold">
        {{ t("header") }}
      </h2>
      @if (isAnyFilterSelected) {
      <button class="rounded-full justify-center items-center gap-2 flex" (click)="SaveSearch()">
        <div class="w-5 h-5 relative">
          <i class="icon-heart-line text-green-700 text-md font-normal"></i>
        </div>
        <button class="text-green-700 text-base font-normal">
          {{ t("grid-list-cards.buttons.saveSearch") }}
        </button>
      </button>
      <div _ngcontent-ng-c85136986="" class="w-[18px] h-[0px] rotate-90 border border-gray-400 hidden md:block"></div>
      }

      <button [localizedRouterLink]="['/account-settings/saved-searches']"
        class="rounded-rounded justify-center items-center gap-2 flex">
        <div class="text-green-700 text-base font-normal underline">
          {{ t("allSavedSearches") }}
        </div>
      </button>
    </div>

    <div class="flex flex-row items-center justify-between w-full gap-4 md:gap-8 relative">
      <div class="flex-1" [ngClass]="[!isSearchOpen
            ? 'max-w-[800px]'
            : 'max-w-[100%] absolute left-0 top-[1px] w-full bg-white z-10 flex flex-row items-center justify-between gap-10'
        ]">
        <app-search-property [searchPlaceholder]="t('maps-search.search-placeholder')" [isFullScreenDdl]="true"
          (ItemSelected)="selectSearchItem($event)" (SearchSelected)="searchWithLocation($event)" [searchByCode]="true"
          (SearchOpen)="isSearchOpen = true" (SearchClose)="isSearchOpen = false" class="flex-1 w-full" />
      </div>
      <!--      <div class="py-1 pr-2 pl-4 border rounded-full border-gray-300 flex flex-row items-center gap-3 flex-1 max-w-[800px]">-->
      <!--        <div class="flex items-center justify-center">-->
      <!--          <i class="icon-search text-gray-400 text-xl"></i>-->
      <!--        </div>-->
      <!--        <input-->
      <!--          type="text"-->
      <!--          class="w-full h-10 bg-transparent text-black text-base font-normal focus:outline-none"-->
      <!--          placeholder="Search"-->
      <!--        >-->
      <!--        <div class="flex items-center gap-2">-->
      <!--          <app-search-badge [text]="'Test Badge'" (removeBadge)="removeBadge($event)">-->
      <!--          </app-search-badge>-->
      <!--          <button type="button" class="btn-secondary whitespace-nowrap py-1 px-1 sm:px-3 min-w-[34px] border-white sm:border-[#C2CCD3]">-->
      <!--            <span>+6</span> <span class="sm:block hidden">more</span>-->
      <!--          </button>-->
      <!--        </div>-->
      <!--      </div>-->

      <div [ngClass]="
          isSearchOpen
            ? 'opacity-0 flex flex-row items-center gap-4 w-full'
            : 'flex flex-row items-center gap-4'
        ">
        <div class="md:block hidden">
          <app-filter-dropdown [dropdownItems]="propertyTypes" [selectedKeys]="selectedType"
            [allValuesLabel]="t('filterTitles.propertyType')" (selectedItem)="searchWithTypeFilter($event)"
            [hasBorder]="false" class="w-full"></app-filter-dropdown>
        </div>
        <div class="lg:block hidden">
          <app-range-dropdown [minDropdownItems]="minPriceRanges" [maxDropdownItems]="maxPriceRanges"
            [preselectedRange]="selectedPriceRange" [allValuesLabel]="t('filterTitles.price')" postfix="€"
            (selectedRangeEvent)="searchWithPriceFilter($event)" class="w-full"
            [hasBorder]="false"></app-range-dropdown>
        </div>
        <div class="xl:block hidden">
          <app-range-dropdown [minDropdownItems]="minSizeRanges" [maxDropdownItems]="maxSizeRanges"
            [preselectedRange]="selectedSizeRange" [allValuesLabel]="t('filterTitles.size')" [postfix]="areaUnit"
            (selectedRangeEvent)="searchWithSizeFilter($event)" class="w-full" [hasBorder]="false"></app-range-dropdown>
        </div>
        <button class="w-14 h-14 min-w-14 rounded-full border border-gray-300 justify-center items-center inline-flex"
          (click)="toggleAdvancedFilers()">
          <div class="w-9 h-9 relative flex flex-col">
            <div class="w-full h-full absolute rounded-full flex items-center justify-center text-white font-bold">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="filter">
                  <g id="Union">
                    <path
                      d="M2 6.72C2 6.32236 2.32236 6 2.72 6H21.92C22.3176 6 22.64 6.32236 22.64 6.72C22.64 7.11765 22.3176 7.44 21.92 7.44H2.72C2.32236 7.44 2 7.11765 2 6.72Z"
                      fill="black"></path>
                    <path
                      d="M4.4 12.72C4.4 12.3224 4.72235 12 5.12 12H19.52C19.9176 12 20.24 12.3224 20.24 12.72C20.24 13.1176 19.9176 13.44 19.52 13.44H5.12C4.72235 13.44 4.4 13.1176 4.4 12.72Z"
                      fill="black"></path>
                    <path
                      d="M8.72 18C8.32236 18 8 18.3224 8 18.72C8 19.1176 8.32236 19.44 8.72 19.44H15.92C16.3176 19.44 16.64 19.1176 16.64 18.72C16.64 18.3224 16.3176 18 15.92 18H8.72Z"
                      fill="black"></path>
                  </g>
                </g>
              </svg>
            </div>
            <div class="w-5 h-5 absolute -top-[10px] left-8 bg-green-600 rounded-full flex flex-col justify-center">
              <span class="text-white text-xs">{{ searchFiltersCount }}</span>
            </div>
          </div>
        </button>
      </div>
    </div>
  </div>
</ng-container>

<!-- <app-sponsored-properties></app-sponsored-properties>
<app-property-tag-filters></app-property-tag-filters> -->
<div>
  <app-grid-list-cards [orderByItems]="this.orderByItems" (onChangePropertyCount)="this.propertyCount = $event"
    [displayMap]="this.displayMap" />
</div>
<app-advanced-filters-drawer [Toggle$]="toggleAdvancedFilters$" (FilterChanged)="searchWithAdvancedFilters($event)"
  (OnHidden)="advancedSearchHidden($event)" [propertyTypes]="propertyTypes" [selectedPriceRange]="selectedPriceRange"
  [maxPriceRanges]="maxPriceRanges" [minPriceRanges]="minPriceRanges" [selectedPriceRange]="selectedPriceRange"
  [selectedType]="selectedType" [minSizeRanges]="minSizeRanges" [maxSizeRanges]="maxSizeRanges"
  [selectedSizeRange]="selectedSizeRange" [sizePostfix]="areaUnit"></app-advanced-filters-drawer>